import { API_BASE } from "./api";

export const fetchSalesman = async (idSalesman) => {
  if (!idSalesman) return null;

  const res = await fetch(
    `${API_BASE}/customers-ultra/api/ws/getSalesman?id_salesman=${idSalesman}`
  );

  if (!res.ok) {
    throw new Error("No se pudo obtener el asesor");
  }

  return res.json();
};
